import styled from "styled-components";

export const Wrapper = styled.div`
  > .ant-typography {
    margin: 0;
  }

  .expandable-text {
    white-space: normal;
    padding-right: 6px;

    .anticon {
      position: absolute;
      top: 0;
      right: 1px;
      color: ${"#595959"};

      &.arrow-up {
        transform: rotate(180deg);
      }
    }
  }
`;
